import React from 'react';

import { CustomSearch as Search } from 'components/commonStyles';

const CustomSearch = ({ size = 'large', ...props }) => (
  <Search size={size} {...props} /> // eslint-disable-line
);

export default CustomSearch;
